import { reportPhishing, dontReportPhishing } from '../../strings.locstring.json';
import { phishingDialogTitle, phishingSubText } from './confirmMarkAsPhishing.locstring.json';
import loc from 'owa-localize';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import * as undoActions from 'owa-mail-undo';

/**
 * Helper method to trigger the confirm dialog before processing mark as phishing
 * @param markAsPhishingActionHandler callback after user confirms the mark as phishing action
 */
export default function confirmMarkAsPhishing(markAsPhishingActionHandler: () => void) {
    undoActions.clearLastUndoableAction();

    return confirm(loc(phishingDialogTitle), loc(phishingSubText), false /* resolveImmediately */, {
        okText: loc(reportPhishing),
        cancelText: loc(dontReportPhishing),

        // Wait until dialog is dismissed to avoid focus interruption
        delayCallbackAfterAnimation: true,
    }).then((response: DialogResponse) => {
        if (response === DialogResponse.ok) {
            markAsPhishingActionHandler();
        }
    });
}
